/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteJsonWebKeySetSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteJsonWebKeySetRequest = {
  /**
   * The ID of the key set to delete.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteJsonWebKeySetSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteJsonWebKeySetSecurity$outboundSchema: z.ZodMiniType<
  DeleteJsonWebKeySetSecurity$Outbound,
  DeleteJsonWebKeySetSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteJsonWebKeySetSecurityToJSON(
  deleteJsonWebKeySetSecurity: DeleteJsonWebKeySetSecurity,
): string {
  return JSON.stringify(
    DeleteJsonWebKeySetSecurity$outboundSchema.parse(
      deleteJsonWebKeySetSecurity,
    ),
  );
}

/** @internal */
export type DeleteJsonWebKeySetRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteJsonWebKeySetRequest$outboundSchema: z.ZodMiniType<
  DeleteJsonWebKeySetRequest$Outbound,
  DeleteJsonWebKeySetRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteJsonWebKeySetRequestToJSON(
  deleteJsonWebKeySetRequest: DeleteJsonWebKeySetRequest,
): string {
  return JSON.stringify(
    DeleteJsonWebKeySetRequest$outboundSchema.parse(deleteJsonWebKeySetRequest),
  );
}
